import { Box, TextField } from "@mui/material"
import type { FC } from "react"

import { FIELD_LABEL_CLASSES, TEXT_FIELD_STYLING_PROPS } from "@/constants/forms"
import type { TestTemplate } from "@/graphql/codegen/graphql"
import {
  getTestTemplateComparisonLabel,
  getTestTemplateResultUomLabel,
} from "@/screens/ManageProducts/components/TestTemplates/utils"

interface TestTemplateInfoProps {
  testTemplate: TestTemplate
}

const TestTemplateInfo: FC<TestTemplateInfoProps> = ({ testTemplate }) => (
  <Box className='flex flex-col gap-6'>
    <Box>
      <label htmlFor='test-template-number-input' className={FIELD_LABEL_CLASSES}>
        Test #
      </label>
      <TextField
        id='test-template-number-input'
        {...TEXT_FIELD_STYLING_PROPS}
        value={testTemplate.externalSystemId}
        disabled
      />
    </Box>
    <Box>
      <label htmlFor='test-template-description-input' className={FIELD_LABEL_CLASSES}>
        Description
      </label>
      <TextField
        id='test-template-description-input'
        {...TEXT_FIELD_STYLING_PROPS}
        value={testTemplate.description}
        disabled
      />
    </Box>
    <Box>
      <label htmlFor='test-template-results-uom-input' className={FIELD_LABEL_CLASSES}>
        Results Unit of Measure
      </label>
      <TextField
        id='test-template-results-uom-input'
        {...TEXT_FIELD_STYLING_PROPS}
        value={getTestTemplateResultUomLabel(testTemplate.resultsUnitOfMeasure)}
        disabled
      />
    </Box>
    <Box>
      <label htmlFor='test-template-comparison-input' className={FIELD_LABEL_CLASSES}>
        Comparison
      </label>
      <TextField
        id='test-template-comparison-input'
        {...TEXT_FIELD_STYLING_PROPS}
        value={getTestTemplateComparisonLabel(testTemplate.comparison)}
        disabled
      />
    </Box>
  </Box>
)

export default TestTemplateInfo
